import React, { useEffect } from "react";
import { observer, inject } from "mobx-react";
import { Redirect, withRouter } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useQuery } from "@apollo/client";
import { TARIFF_TAGS_QUERY, PROVIDER_AVAILABILITY_OPERATOR_QUERY } from "Services/queries";
import withDefaultParams, { generateUrl } from "Services/withDefaultParams";
import { sendMetriks } from "Services/sendMetriks";
import configRouters from "Configs/routes";
import { pipe } from "Utils";
import { isMainSiteCode } from "Utils/siteConfig";
import SeoBlockHOC from "HOC/SeoBlockHOC";
import { PROVIDER_TAB_TARIFFS } from "stores/ProviderModel";
import RecentlyConnectedTariffsContainer from "Containers/RecentlyConnectedTariffsContainer";
import YandexWidgetReviews from "Containers/YandexWidgetReviews";
import TopProviderContainer from "Containers/TopProviderContainer";
import { PaddingTop } from "ComponentsUI/Spacings";
import NoFindTariffs from "ComponentsUI/NoFindTariffs";
import { RedirectPagination } from "ComponentsUI/Redirects";
import TarifficationList from "../tarifficationList";
import { Container } from "reactstrap";
import { SeoBlockContainer } from "Containers/SeoBlock";

const ProviderRates = (props) => {
	useEffect(() => {
		const {
			ApplicationModel: { providerModel },
			providerForCard: { vip_provider },
		} = props;
		if (providerModel.visibleTab !== PROVIDER_TAB_TARIFFS) {
			providerModel.changeTab(PROVIDER_TAB_TARIFFS);
		}
		if (vip_provider) {
			sendMetriks("PROVIDER_VIP");
		}
	}, []);
	const canonical = () => {
		const {
			ApplicationModel: { siteConfig },
		} = props;

		const location = generateUrl(configRouters.ProviderRates.route, {
			regionUrl: props.match.params.regionUrl,
			providerName: props.match.params.providerName,
		});

		return (
			<Helmet>
				<link
					rel="canonical"
					href={`${siteConfig.ssl === true ? `https` : "http"}://${
						siteConfig.domain_name_full
					}${location}`}
				/>
			</Helmet>
		);
	};

	const {
		ApplicationModel: { text },
		match,
		providerForCard,
		route,
	} = props;
	let isMobile = props.ApplicationModel.windowSizeModel.windowSizes.xs;
	const siteCode = props.ApplicationModel.siteCode;

	const tariffsTagsQuery = useQuery(TARIFF_TAGS_QUERY, {
		variables: {
			filter: `region.url=${match.params.regionUrl}&provider.url_name=${match.params.providerName}`,
			providerPage: true,
		},
		skip: !match.params.regionUrl || !match.params.providerName,
	});
	const operatorTagQuery = useQuery(PROVIDER_AVAILABILITY_OPERATOR_QUERY, {
		variables: {
			global_id: providerForCard?.global?.id || 0,
			url_region: match.params.regionUrl,
		},
		skip: !match.params.regionUrl || !providerForCard || !providerForCard.global,
	});

	let tariffTags = tariffsTagsQuery?.data?.tariffsTags?.data;
	let operatorTag = operatorTagQuery?.data?.providerAvailabilityOperator;

	if (!providerForCard?.info?.cnt_tariffs) {
		let location = {
			pathname: generateUrl(configRouters.ProviderDetails.route, {
				regionUrl: match.params.regionUrl,
				providerName: match.params.providerName,
			}),
			state: {
				isRedirect: true,
			},
		};
		return <Redirect to={location} />;
	}

	if (match.params.page === "1") {
		return <RedirectPagination />;
	}
	return (
		<>
			{canonical()}
			{isMainSiteCode(siteCode) && <div></div>}
			<PaddingTop>
				<div
					style={{
						display: "block",
					}}
				>
					<Container>
						<SeoBlockContainer route={route} placeText="SeoBlock1" bgText={true} />
					</Container>
					{!!providerForCard?.info?.cnt_tariffs && (
						<>
							<TarifficationList
								providerForCard={providerForCard}
								tariffTags={tariffTags}
								operatorTag={operatorTag}
								isRates={true}
								text={text}
								isMobile={isMobile}
								skipLayout={true}
							/>
							<YandexWidgetReviews />
						</>
					)}
					{!providerForCard?.info?.cnt_tariffs && (
						<>
							<NoFindTariffs text={text} />
							<SeoBlockHOC route={route} placeText="TopProvider">
								<TopProviderContainer />
							</SeoBlockHOC>

							<RecentlyConnectedTariffsContainer
								{...props}
								isRates={true}
								skipLayout={true}
								pageName={providerForCard?.vip_provider ? "vip_card" : "no_vip_card"}
							/>
						</>
					)}
				</div>
			</PaddingTop>
			<Container>
				<SeoBlockContainer route={route} placeText="SeoBlock2" bgText={true} />
				<SeoBlockContainer route={route} placeText="SeoBlock3" bgText={true} />
			</Container>
		</>
	);
};

export default pipe(
	observer,
	inject("ApplicationModel"),
	withDefaultParams,
	withRouter
)(ProviderRates);
